import allConfig from '../../config'
import { getCurrentCountry } from '../utils';

export const getConfig = (key?:string):string|boolean|number|KeyValue => {
  const config = getConfigEntry().config
  if(!key) return config;
  return config[key]
}

export const getConfigEntry=(configName: string = getCurrentCountry()):KeyValue=>{
  return allConfig.filter(entry=>entry.name===configName).shift() ?? {}
}